"use client";

import classNames from "classnames";
import styles from "./LoadingScreen.module.scss";

type LoadingScreenProps = {
  /** Full-viewport overlay (e.g. during client-side navigation). */
  overlay?: boolean;
  logoSrc?: string;
};

export const LoadingScreen = ({
  overlay = false,
  logoSrc = "/assets/brandmark-light.svg",
}: LoadingScreenProps) => {
  return (
    <div
      className={classNames(styles.root, overlay && styles.rootOverlay)}
      role="status"
      aria-live="polite"
      aria-label="Loading"
    >
      <div className={styles.wrapper}>
        <div className={styles.spinner} aria-hidden />
        <img
          className={styles.logo}
          src={logoSrc}
          alt=""
          width={281}
          height={353}
          decoding="async"
        />
      </div>
    </div>
  );
};
